import { render, staticRenderFns } from "./AppointmentCell.vue?vue&type=template&id=2bdedf77&scoped=true"
import script from "./AppointmentCell.vue?vue&type=script&lang=ts"
export * from "./AppointmentCell.vue?vue&type=script&lang=ts"
import style0 from "./AppointmentCell.vue?vue&type=style&index=0&id=2bdedf77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdedf77",
  null
  
)

export default component.exports